export default "__VITE_PUBLIC_ASSET__d0c67e51__"